
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ZoomInIconComponent } from "./zoom-in-icon.svg";

export const ZoomInIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ZoomInIconComponent {...props} />;
};
